export enum LinkableItemLifecycleStates {
    SELECTED = 'selected',
    IN_TRANSIT = 'inTransit',
    FINALIZED = 'finalized',
}

export interface StateNode<T> {
    availableLifecycleStates?: T[];
    name: T;
}

export interface LinkableItem {
    arrivalLocation: string;
    linkableItem: string;
    modifyPermanentLocation: boolean;
    state: StateNode<LinkableItemLifecycleStates>;
    linkableItemReferenceType: string;
}

export interface LinkableItemStateResource {
    state: LifecycleStateResource
    linkableItem: LinkableArchiveItemResource
    createdInRecord: boolean
}

export interface LifecycleStateResource {
    name?: string
    availableLifecycleStates?: string[]
}

export interface LinkableItemRef {
    id?: string
    classNameSkin?: string
}

export interface WorkflowSchema<T> {
    currentState: StateNode<T>;
    linkableItems: LinkableItem[];
}

export interface LinkableArchiveItemResource {
    linkableItemReferenceType?: string | null
    linkableItem?: string | null
}

export interface LinkableSpecimenItemResource {
    linkableItemReferenceType?: string | null
    linkableItem?: string | null
}